import styled from 'styled-components';

export const ContactContainer = styled.div`
  padding-top: 80px;
  min-height: 100vh;
`;

export const ContactHero = styled.div`
  position: relative;
  height: 40vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
  overflow: hidden;

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
  }
  
  & > h1 {
    position: relative;
    z-index: 1;
  }
`;

export const ContactContent = styled.div`
  max-width: 1200px;
  margin: 4rem auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 3rem;
    margin: 2rem auto;
    padding: 0 1rem;
  }
`;

export const ContactForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  
  @media (max-width: 480px) {
    gap: 0.3rem;
  }
`;

export const Input = styled.input`
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
  
  @media (max-width: 480px) {
    padding: 0.6rem;
  }
`;

export const TextArea = styled.textarea`
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
  min-height: 150px;
`;

export const SubmitButton = styled.button`
  background: #007bff;
  color: white;
  border: none;
  padding: 1rem;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s;

  &:hover {
    background: #0056b3;
  }
`;

export const ContactInfo = styled.div`
  h3 {
    margin-bottom: 1.5rem;
  }

  .info-row {
    display: flex;
    align-items: center;
    gap: 0.7rem;
    margin-bottom: 1rem;
    font-size: 1.1rem;
  }

  .info-link {
    color: #007bff;
    text-decoration: none;
    transition: color 0.2s;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .info-link:hover {
    color: #25d366;
  }

  .map-container {
    width: 100%;
    height: 180px;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 1.5rem;
    box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  }


  .p {
    margin-bottom: 1rem;
  }
`;

export const Select = styled.select`
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
  
  @media (max-width: 480px) {
    padding: 0.6rem;
  }
`;